import { Component, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { MenuItem } from "primeng/api";
import { Subject } from "rxjs";
import { ScannerInputComponent } from "@/shared/scanner-input.component";

@Component({
  selector: "uni-inventory-manager",
  standalone: false,
  templateUrl: "./inventory-manager.component.html",
})
export class InventoryManagerComponent {
  @ViewChild("scannerInput") scannerInput: ScannerInputComponent<string>;

  isSidebarCollapsed = false;

  constructor(private router: Router) {}

  toggleSidebar(): void {
    this.isSidebarCollapsed = !this.isSidebarCollapsed;
  }

  // Inventory page buttons
  printBarcodesClicked$ = new Subject<void>();
  canPrintBarcodes = false;
  showPrintBarcodesButton = false;

  // Add Inventory page buttons
  addBlankItemDetailClicked$ = new Subject<void>();
  copySelectedItemDetailClicked$ = new Subject<void>();
  showAddInventoryButtons = false;

  // Inventory Maintenance (Scan) page
  showScannerControls = false;
  scannerDisabled = false;
  scannerSearchFn: (value: string) => Promise<string | null>;
  scannerSubmitted$ = new Subject<string>();

  // EOQ Calculator page buttons
  showFormulaClicked$ = new Subject<void>();
  canShowFormula = false;
  showEoqButtons = false;
  showPercentages = false;
  showPercentagesChanged$ = new Subject<boolean>();

  items: MenuItem[] = [
    {
      label: '<span class="text-l font-bold">Inventory</span>',
      escape: false,
      expanded: true,
      items: [
        {
          label: "Inventory",
          icon: "pi pi-fw pi-box",
          routerLink: ["/inventory/manage/inventory"],
        },
        {
          label: "Scan & Reconcile",
          icon: "pi pi-fw pi-qrcode",
          routerLink: ["/inventory/manage/inventory-scan"],
        },
        {
          label: "Item Lookup",
          icon: "pi pi-fw pi-search",
          routerLink: ["/inventory/manage/inventory-lookup"],
        },
        {
          label: "Add Inventory",
          icon: "pi pi-fw pi-plus",
          routerLink: ["/inventory/manage/add-inventory"],
        },
        {
          label: "EOQ Calculator",
          icon: "pi pi-fw pi-calculator",
          routerLink: ["/inventory/manage/inventory-eoq"],
        },
      ],
    },
  ];

  updatePrintBarcodesEnabled(enabled: boolean) {
    this.canPrintBarcodes = enabled;
  }

  printBarcodes() {
    this.printBarcodesClicked$.next();
  }

  addBlankItemDetail() {
    this.addBlankItemDetailClicked$.next();
  }

  copySelectedItemDetail() {
    this.copySelectedItemDetailClicked$.next();
  }

  updateShowFormulaEnabled(enabled: boolean) {
    this.canShowFormula = enabled;
  }

  showFormula() {
    this.showFormulaClicked$.next();
  }

  goProductTypes() {
    this.router.navigate(["/references/manage/product-types"]);
  }

  toggleShowPercentages() {
    this.showPercentages = !this.showPercentages;
    this.showPercentagesChanged$.next(this.showPercentages);
  }

  // Scanner methods - called by child page to register its search function
  setScannerSearchFn(fn: (value: string) => Promise<string | null>) {
    this.scannerSearchFn = fn;
  }

  clearAndFocusScanner() {
    this.scannerInput?.clear();
    setTimeout(() => {
      this.scannerInput?.focus();
    }, 1);
  }

  setScannerError(error: string) {
    if (this.scannerInput) {
      this.scannerInput.errorMessage = error;
    }
  }

  onScannerResult(result: string) {
    // Emit to child - the scanner component already handles clear/focus
    this.scannerSubmitted$.next(result);
  }

  onScannerError(error: string) {
    // Error is already displayed by scanner component
  }
}
